import axios from "axios";
import { clearAllReduxStates } from "./clearState";
import { persistor } from "../../store/store";
import { setLogoutSession } from "../../services/slices/authTokenSlice";
import { responseData } from "../../utils/helpers/helper";

export const NO_RESPONSE_MESSAGE = "Unable to reach the server. Please check your connection and try again.";

// `token` is unused: the session travels in httpOnly cookies (see services/http-client.js).
// The parameter stays so existing get/post/remove call sites keep their positions.
const fetchApi = async (
    endPoint, method, controller = null, payload = null,
    setLoading, setError,
    token = null, navigate, dispatch, params = null, extraHeaders = {}
) => {
    try {
        setLoading(true);
        controller.current = new AbortController();
        let url;
        if (endPoint.includes("dashboardcharts")) {
            url = `${process.env.REACT_APP_API_URL}${`${endPoint}/${JSON.stringify(params)}`}`;
        } else {
            url = `${process.env.REACT_APP_API_URL}${endPoint}`;
        }
        const jsonConfig = {
            headers: {
                'Accept': 'application/json',
                "Content-Type": "application/json",
                // Spread any caller-supplied headers
                ...extraHeaders,
            },
            signal: controller.current.signal,
        };

        const results = (method === "post" || method === "put" || method === "patch") ?
            await axios?.[method](url, payload, jsonConfig) :
            await axios?.[method](url, jsonConfig);
        const result = responseData(results)
        if ((!result?.data?.success) && result?.data?.message) {
            setError(result.message);
        }
        return ({
            data: result,
            status: results?.statusText === "OK"
        });
    } catch (errors) {
        let error = responseData(errors?.response)
        // Network/CORS failure, failed channel handshake or a proxy error page: there is no API message to show.
        // A cancelled request (navigation, unmount) is deliberate and stays silent.
        if (!error?.message && !axios.isCancel(errors)) {
            error = { ...error, message: NO_RESPONSE_MESSAGE };
        }
        setLoading(false);
        setError(error?.message);
        if (errors?.response?.status === 401 && error?.message === "New login found.") {
            dispatch(setLogoutSession(true));
        } else if (errors?.response?.status === 401) {
            clearAllReduxStates(dispatch);
            persistor.purge();
            sessionStorage.clear();
            localStorage.clear();
            navigate("/");
        }
        if (endPoint === "globaldownload" || endPoint === "shopdownload") {
            return error?.response || error
        }
        if (error?.message === "User does not have viewer license!") {
            return error?.message;
        } else {
            (console.log("API failed", error?.message))
            return error?.message
        }
    } finally {
        setLoading(false);
    }
};


// GET method //
export const get = async (endPoint, controller, SetLoading = () => { }, setError = () => { }, token, navigate, dispatch, params) => {
    return await fetchApi(endPoint, 'get', controller, null, SetLoading, setError, token, navigate, dispatch, params);
}

// POST method — supports optional extraHeaders //
export const post = async (endPoint, controller, data, setLoading = () => { }, setError = () => { }, token, navigate, dispatch, extraHeaders = {}) => {
    return await fetchApi(endPoint, 'post', controller, data, setLoading, setError, token, navigate, dispatch, null, extraHeaders);
}

// DELETE method //
export const remove = async (endPoint, controller, SetLoading = () => { }, setError = () => { }, token, navigate, dispatch) => {
    return await fetchApi(endPoint, 'delete', controller, null, SetLoading, setError, token, navigate, dispatch);
}
